var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container pb-4" }, [
    _c("div", { staticClass: "row mb-4" }, [
      _c(
        "div",
        {
          staticClass:
            "col-sm-10 offset-sm-1 col-md-8 offset-md-2 text-center mb-3"
        },
        [
          _c("form", [
            _c("div", { staticClass: "row" }, [
              _vm.brand_categories
                ? _c("div", { staticClass: "col-12 col-lg-6 mt-1" }, [
                    _c("div", { staticClass: "form-group mb-1 mb-md-0" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.category,
                              expression: "category"
                            }
                          ],
                          staticClass: "form-control selectpicker",
                          attrs: {
                            id: "brand-category",
                            name: "brand-category"
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.category = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              function($event) {
                                return _vm.pushHistoryState()
                              }
                            ]
                          }
                        },
                        [
                          _c(
                            "option",
                            { staticClass: "d-none", attrs: { value: "" } },
                            [
                              _vm._v(
                                _vm._s(_vm.filter_labels["select_category"])
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.brand_categories, function(category) {
                            return _c(
                              "option",
                              {
                                key: category.id,
                                domProps: { value: category.id }
                              },
                              [_vm._v(_vm._s(category.name))]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-6 mt-1" }, [
                _c("div", { staticClass: "form-group mb-1 mb-md-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search_term,
                        expression: "search_term"
                      }
                    ],
                    staticClass: "form-control search-field",
                    attrs: {
                      type: "text",
                      name: "brand",
                      placeholder: _vm.filter_labels["type_brand_name"]
                    },
                    domProps: { value: _vm.search_term },
                    on: {
                      change: _vm.pushHistoryState,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search_term = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "row container-shadow mb-2 bg-secondary bg-pattern-white bg-repeat-300px"
      },
      _vm._l(_vm.brands, function(brand) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.category == "" && _vm.search_term == "") ||
                  (brand.category == _vm.category && _vm.search_term == "") ||
                  (brand.name
                    .toUpperCase()
                    .indexOf(_vm.search_term.toUpperCase()) !== -1 &&
                    _vm.category == "") ||
                  (brand.category == _vm.category &&
                    brand.name
                      .toUpperCase()
                      .indexOf(_vm.search_term.toUpperCase()) !== -1),
                expression:
                  " \n                (category == '' && search_term == '') || \n                (brand.category == category && search_term == '') || \n                (((brand.name).toUpperCase().indexOf(search_term.toUpperCase()) !== -1) && category == '') || \n                (brand.category == category && ((brand.name).toUpperCase().indexOf(search_term.toUpperCase()) !== -1))\n              "
              }
            ],
            key: brand.id,
            staticClass: "col-6 col-md-3 col-lg-2 p-0"
          },
          [
            _c("a", { attrs: { href: brand.permalink } }, [
              _c(
                "div",
                {
                  staticClass: "brand-pod",
                  style: { "background-image": "url(" + brand.image + ")" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "content d-flex flex-column align-items-center justify-content-end"
                    },
                    [
                      _c("h3", {
                        staticClass: "text-white",
                        domProps: { innerHTML: _vm._s(brand.name) }
                      })
                    ]
                  )
                ]
              )
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-loader/lib?{}!./scripts/vue/brands.vue?vue&type=template&id=5cd0bb60&
// module id = 49
// module chunks = 0